var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/library/modules/_html.js
// module id = q01l
// module chunks = 5 6 7 8